// src/pages/MS/MSU101F4.jsx
import React, {useEffect, useState} from 'react';

import Button from "components/Button/Button";
import SelectBox from "components/SelectBox/SelectBox";
import RadioGroup from "components/Radio/RadioGroup";
import SwitchGroup from "components/Button/SwitchGroup";
import {postData} from "utils/TransactionUtil";


import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import DatePicker from "../../components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from "../RE/REGComUtil";
import TextArea from "../../components/TextArea/TextArea";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";


const MSU101F4 = ({handle_Close, tarLginId, tarUserNm, comHandleClick_Save}) => {

    // useEffect(() => {
    // }, []);


    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            if(checkEssential()){
                svcSecurePwReset();
            }
        });
    }, [comHandleClick_Save]);




    const [userDtl, setUserDtl] = useState({
        lginId:tarLginId, userPw1:'', userPw2:''
    });


    /* Event ==================================================================================================== */


    function checkEssential() {
        let result = true;

        //패스워드 체크
        const idRegEx =  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,16}$/;
        const validatePw = (pw) => {
            return idRegEx.test(pw);
        };

        if(!validatePw(userDtl.userPw1)){
            result=false;
            toast({ type: 'warning', message: '패스워드 규칙을 확인해주세요.'});
        }else if(userDtl.userPw1 !== userDtl.userPw2){
            result=false;
            toast({ type: 'warning', message: '패스워드/확인값이 다릅니다.'});
        }else if(userDtl.lginId === ""){
            result=false;
            toast({ type: 'warning', message: '작업 대상ID를 확인할 수 없습니다.'});
        }



        return result;
    }



    /* Call Service====================================================================================================*/



    async function svcSecurePwReset() {

        //사용자 등록
        let result = await postData("/MSU/setMngPwReset", userDtl);
        handle_Close();
        toast({ type: 'info', message: '암호 초기화가 완료되었습니다.'});


    }


    return(
        <>
            <div className={styleCom.main_wrap} style={{ marginBottom: "10px"}}>
                <Table variant='default' rowCnt={4} colSize={['30%', '70%']} rowSize={'56px'}>
                    <div>사용자 ID</div>
                    <div>
                        {tarLginId}
                    </div>
                    <div>사용자명</div>
                    <div>
                        {tarUserNm}
                    </div>


                    <div>패스워드</div>
                    <div>
                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userPw1}
                                       onChange={(value) => setUserDtl({...userDtl, userPw1: value})}/>
                        <div style={{color: "gray", fontSize: "12px"}}>
                            8~16자(영문/숫자/특수문자를 혼합하여 사용하십시오)
                        </div>
                    </div>
                    <div>패스워드 확인</div>
                    <div>
                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userPw2}
                                       onChange={(value) => setUserDtl({...userDtl, userPw2: value})}/>
                    </div>

                </Table>
            </div>
        </>
    )
}
export default MSU101F4;